module.exports = __webpack_public_path__ + "assets/img/warrior-name-05625657.png";